import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingStep: React.FC = () => {
  return (
    <div className="activation-step">
      <div className="activation-step__content">
        <div className="activation-loading">
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            size="large"
          />
          <h2 className="activation-step__title">Loading...</h2>
          <p className="activation-step__subtitle">
            Please wait while we prepare your activation page...
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingStep;
